import { Button, Stack, Typography } from "@mui/material";
import { useGetActivePushNotificationCount } from "../hooks";
import { Loader } from "../../../shared";

export const DeleteDialogContent = ({
  closeModal,
  handleDelete,
  id,
  isDeleting,
}) => {
  const { count, loading } = useGetActivePushNotificationCount(id);

  return loading ? (
    <Stack alignItems="center" justifyContent="center" height="100%">
      <Loader />
    </Stack>
  ) : (
    <>
      <Typography fontSize="14px" fontWeight={400} lineHeight="16px">
        {count === 0 ? (
          " Are you sure you want to delete this coupon?"
        ) : (
          <>
            This action will also cancel {count} push{" "}
            {count === 1 ? "notification" : "notifications"} created for this
            coupon. Are you sure you want to delete this coupon?
          </>
        )}
      </Typography>
      <Stack flexDirection="row" justifyContent="flex-end" mt={2} gap={1.5}>
        <Button
          size="small"
          variant="text"
          color="info"
          onClick={() => closeModal()}
        >
          No
        </Button>
        <Button
          size="small"
          variant="contained"
          disabled={isDeleting}
          onClick={() => {
            closeModal();
            if (id) {
              handleDelete(id);
            }
          }}
        >
          Yes
        </Button>
      </Stack>
    </>
  );
};
